import { AxiosResponse } from 'axios';
import { appContextGet, appContextPost, appContextPut } from './httpCommon/appAxios.service';
import { ACCOUNT_TANK_MAINTENANCE_ENDPOINTS } from '../constants/apiEndpoints';
import { PagedResponse } from '../types/interfaces';
import {
  AccountTankDueSummary,
  AccountTankMaintenance,
  AccountTankMaintenanceHistory,
  AccountTankMaintenanceSetting,
  LogAccountTankMaintenanceRequest,
  SaveAccountTankMaintenanceSettingRequest,
} from '../types/interfaces/accountTankMaintenance.interfaces';

export const getAccountTankMaintenanceSettings = (
  maintenanceTypeId?: number,
): Promise<AxiosResponse<AccountTankMaintenanceSetting>> => {
  return appContextGet(ACCOUNT_TANK_MAINTENANCE_ENDPOINTS.SETTINGS, { ...(maintenanceTypeId ? { maintenanceTypeId } : {}) });
};

export const saveAccountTankMaintenanceSettings = (
  payload: SaveAccountTankMaintenanceSettingRequest,
): Promise<AxiosResponse<AccountTankMaintenanceSetting>> => {
  return appContextPut(ACCOUNT_TANK_MAINTENANCE_ENDPOINTS.SETTINGS, payload);
};

export const getAccountTankMaintenance = (
  tankId: number,
  maintenanceTypeId?: number,
): Promise<AxiosResponse<AccountTankMaintenance>> => {
  return appContextGet(ACCOUNT_TANK_MAINTENANCE_ENDPOINTS.BASE_ + tankId, {
    ...(maintenanceTypeId ? { maintenanceTypeId } : {}),
  });
};

export const getAccountTankMaintenanceHistory = (
  tankId: number,
  params?: { limit?: number; offset?: number },
): Promise<AxiosResponse<AccountTankMaintenanceHistory[] | PagedResponse<AccountTankMaintenanceHistory>>> => {
  return appContextGet(ACCOUNT_TANK_MAINTENANCE_ENDPOINTS.BASE_ + tankId + ACCOUNT_TANK_MAINTENANCE_ENDPOINTS.HISTORY, params);
};

export const logAccountTankMaintenance = (
  tankId: number,
  payload: LogAccountTankMaintenanceRequest,
): Promise<AxiosResponse<AccountTankMaintenanceHistory>> => {
  return appContextPost(ACCOUNT_TANK_MAINTENANCE_ENDPOINTS.BASE_ + tankId + ACCOUNT_TANK_MAINTENANCE_ENDPOINTS.HISTORY, payload);
};

export const getAccountTankMaintenanceDueList = (maintenanceTypeId?: number): Promise<AxiosResponse<AccountTankDueSummary[]>> => {
  return appContextGet(ACCOUNT_TANK_MAINTENANCE_ENDPOINTS.DUE_LIST, { ...(maintenanceTypeId ? { maintenanceTypeId } : {}) });
};
